import types from './types';

const defaultState = {
  open: false
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case types.TOGGLE_SDS_COPY_MODAL:
      return {
        ...state,
        open: action.state
      };
    default:
      return state;
  }
};
